<template>
    <div class="single-slide" :style="`background-image:url(${image});`">
        <div class="container">
            <div class="row">
                <div class="slider-wrapper">
                    <div class="slider-text">
                        <h1>{{title}}</h1>
                        <p>
                            {{description}}
                        </p>
                        <a href="#" v-scroll-to="'#cal-contact-us'" class="btn cal-btn-primary mt-15">{{action}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SliderItem',
        props: {
            image: {
                required: true
            },
            title: {
                required: true
            },
            description: {
                required: true
            },
            action: {
                required: true
            }
        },
        components: {},
        data () {
            return {};
        },
        methods: {}
    };
</script>
